// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__7EnME","title":"styles_title__YOznr","description":"styles_description__sK3Zm","content":"styles_content__58vKT"};